import campaignsData from '../../content/dist/campaigns.json';

/**
 * Get the complete list of level IDs to load.
 * In development, includes both canonical levels and debug levels.
 * In production, only includes canonical levels.
 */
export function getLevelManifest(): string[] {
  // Canonical levels from campaigns.json
  const canonicalLevels = [
    ...campaignsData.campaigns.flatMap(c => c.levelIds),
    'sandbox'
  ];

  return canonicalLevels;
}

/**
 * Get all level IDs across all campaigns (excluding sandbox).
 * Used for progression and unlocking logic.
 */
export function getAllLevelIds(): string[] {
  return campaignsData.campaigns.flatMap(c => c.levelIds);
}

/**
 * Find the campaign that contains the given level ID.
 * @param levelId - The level identifier (e.g., '1-1')
 * @returns The campaign object or null if not found
 */
export function getCampaignForLevel(levelId: string) {
  return campaignsData.campaigns.find(c => c.levelIds.includes(levelId)) || null;
}
